<button
  class="bg-[#FCFCFC] py-3 px-4 my-2.5 flex justify-between rounded-xl border border-[#F1F3F5] items-center w-full justify-items-start gap-x-4"
  [class.border-checked]="checked()"
  [class.border-unchecked]="!checked()"
  mat-ripple
  (click)="click()"
>
  <div class="text-start">
    <p class="text-base font-semibold">
      {{ label() }}
    </p>
    <p class="text-sm">
      {{ subtitle() }}
    </p>
  </div>
  @if (checked()) {
    <div>
      <mat-icon class="text-base hotel-color"> check_circle </mat-icon>
    </div>
  } @else {
    <div>
      <mat-icon class="text-base hotel-color"> radio_button_unchecked </mat-icon>
    </div>
  }
</button>
